import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "./assets/common.css";
import "element-ui/lib/theme-chalk/index.css";
import "./plugins/element.js";
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// ====== 百度地图说明 ======
// 不再全局 Vue.use(BaiduMap, { ak }) —— vue-baidu-map 会通过 document.write
// 在所有页面（登录/控制台/单位管理/...）自动加载百度 SDK，如果 AK 无效或域名不匹配，
// 百度 SDK 内部的 null.rd 错误会被 window.onerror 捕获成 Script error 炸掉整个应用。
// 改用懒加载：需要地图的页面自行 import loadBMap(ak) 加载 window.BMap，
// vue-baidu-map 的 BaiduMap 组件在组件内局部注册即可（import { BaiduMap } from 'vue-baidu-map'）。

// import imageResize from 'quill-image-resize-module' // 调整大小组件。
// import { ImageDrop } from 'quill-image-drop-module'; // 拖动加载图片组件。
// Quill.register('modules/imageResize', imageResize);
// Quill.register('modules/imageDrop', ImageDrop);
Vue.config.productionTip = false;
Vue.prototype.headerCellStyle = {
  backgroundColor: '#409EFF',
  color: '#fff',
}
// 全局过滤器
Vue.filter('dateFormat', function (v) {
  let date = new Date(v)
  if (Number.isNaN(Number(date))) {
    date = new Date()
  }
  let y = date.getFullYear()
  let mon = (date.getMonth() + 1 + '').padStart(2, '0')
  let d = (date.getDate() + '').padStart(2, '0')
  let h = (date.getHours() + '').padStart(2, '0')
  let min = (date.getMinutes() + '').padStart(2, '0')
  let s = (date.getSeconds() + '').padStart(2, '0')
  return [y, mon, d].join('-') + ' ' + [h, min, s].join(':')
})
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
